/* global document */
import inDOM from 'dom-helpers/util/inDOM';
import isIE11 from './isIE11';

const supportsInvertFilter = inDOM && (() => {
  const el = document.createElement('a');
  el.style.cssText = 'filter:invert(100%);';
  return !!el.style.length && !isIE11;
})();

export default supportsInvertFilter;
